import { Box } from "@mui/material"
import { FunctionField, TextField } from "react-admin"
import { InvoiceReadModel } from "../../../GeneratedClients/FreeBillApi"

const FooterComponent = () => {

  const FONTSIZE = 11
  const COLOR = 'grey'

  return (
    <Box color={COLOR} display={"flex"} justifyContent={"space-between"}>
      <Box>
        <TextField fontSize={FONTSIZE} display={'block'} source="invoiceIssuer.company.companyName" />
        <FunctionField fontSize={FONTSIZE} display={'block'} render={(invoice: InvoiceReadModel) => `${invoice.invoiceIssuer?.company?.street}, ${invoice.invoiceIssuer?.company?.postCode} ${invoice.invoiceIssuer?.company?.city}`} />
        <FunctionField fontSize={FONTSIZE} display={'block'} render={(invoice: InvoiceReadModel) => invoice.invoiceIssuer?.company?.localCourt && `Registergericht: ${invoice.invoiceIssuer?.company?.localCourt}`} />
        <FunctionField fontSize={FONTSIZE} display={'block'} render={(invoice: InvoiceReadModel) => invoice.invoiceIssuer?.company?.hrbNumber && `Registernummer: ${invoice.invoiceIssuer?.company?.hrbNumber}`} />
        <FunctionField fontSize={FONTSIZE} display={'block'} render={(invoice: InvoiceReadModel) => invoice.invoiceIssuer?.company?.managingDirector && `Geschäftsführer: ${invoice.invoiceIssuer?.company?.managingDirector}`} />
        <TextField fontSize={FONTSIZE} display={'block'} source="invoiceIssuer.taxInfo" />
      </Box>
      <Box>
        <TextField fontSize={FONTSIZE} display={'block'} source="invoiceIssuer.bankAccount.bankName" />
        <FunctionField fontSize={FONTSIZE} display={'block'} render={(invoice: InvoiceReadModel) => invoice.invoiceIssuer?.bankAccount?.accountOwner && `Kontoinhaber: ${invoice.invoiceIssuer?.bankAccount?.accountOwner}`} />
        <FunctionField fontSize={FONTSIZE} display={'block'} render={(invoice: InvoiceReadModel) => invoice.invoiceIssuer?.bankAccount?.iban && `IBAN: ${invoice.invoiceIssuer?.bankAccount?.iban}`} />
        <FunctionField fontSize={FONTSIZE} display={'block'} render={(invoice: InvoiceReadModel) => invoice.invoiceIssuer?.bankAccount?.bic && `BIC: ${invoice.invoiceIssuer?.bankAccount?.bic}`} />
      </Box>
    </Box>
  )
}

export default FooterComponent